import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType} from 'vue';
import {ContactHistoryEmail} from '@/model/ContactHistoryEmail';
import ContactHistory from '@/model/ContactHistory';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiEmailItem',
  props: {
  email: {
    type: Object as PropType<ContactHistoryEmail>,
    required: true,
  },
  contactHistory: {
    type: Object as PropType<ContactHistory>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

__expose({
  props,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    to: {name: 'contact_histories_email', params: {
    id: __props.contactHistory.KundenNr,
    contact_history_id: __props.contactHistory.Nr,
    email_id: __props.email.Id,
  }}
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_icon, {
        color: __props.email.color
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.email.stateIcon), 1)
        ], undefined, true),
        _: 1
      }, 8, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, { style: {"white-space":"normal"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.email.Datei.Dateiname ?? 'Kein Betreff'), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_list_item_subtitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.email.AnlageDatumFormatted), 1)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}
}

})